import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { EmailInterface } from '@contracts/interfaces/email.interface';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

    constructor(private http: HttpClient,
        private connectionService: ConnectionService ) {}

    find(find: any, start: number, limit: number) {
        return this.http.post(this.connectionService.address + "/customer-service/find", {find, start, limit});
    }

    search(search: any, limit: number) {
        return this.http.post(this.connectionService.address + "/customer-service/search", {search, limit});
    }

    findOne(id: string) {
        return this.http.post(this.connectionService.address + "/customer-service/find-one", {id});
    }

    createOne(customer: CustomerInterface) {
        return this.http.post(this.connectionService.address + "/customer-service/create-one", {customer});
    }

    updateOne(customer: CustomerInterface) {
        return this.http.post(this.connectionService.address + "/customer-service/update-one", {customer});
    }

    deleteOne(customer: CustomerInterface) {
        return this.http.post(this.connectionService.address + "/customer-service/delete-one", {customer});
    }
    
    import (source: string, content: any) {
        return this.http.post(this.connectionService.address + "/customer-service/import-" + source, {content})
    }

    edit() {
        
    }
}
